import { render, staticRenderFns } from "./ChatHero.vue?vue&type=template&id=4dbb64f6"
import script from "./ChatHero.vue?vue&type=script&lang=js"
export * from "./ChatHero.vue?vue&type=script&lang=js"
import style0 from "./ChatHero.vue?vue&type=style&index=0&id=4dbb64f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports